import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=fa735aa8&"
import script from "./PaymentMethod.vue?vue&type=script&lang=js&"
export * from "./PaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa735aa8')) {
      api.createRecord('fa735aa8', component.options)
    } else {
      api.reload('fa735aa8', component.options)
    }
    module.hot.accept("./PaymentMethod.vue?vue&type=template&id=fa735aa8&", function () {
      api.rerender('fa735aa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PaymentMethod.vue"
export default component.exports